module.exports = __webpack_public_path__ + "b9806a751033e98b89353d2c46c13f62.png";